import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {PagerService} from 'app/common/services/Pagination.service';
import {ImageService} from 'app/pages/imageService';
import * as moment from 'moment';
import {IOption} from 'ng-select';
import {BsModalService, ModalDirective} from 'ngx-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';
// import {IntegrateLoyaltyServices} from './services/integrate-loyalty.services';
import {environment} from '../../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-integrate-loyalty',
  templateUrl: './integrate-loyalty-v2.component.html',
  styleUrls: ['./integrate-loyalty-v2.component.css'],
  // providers: [IntegrateLoyaltyServices],
})

// tslint:disable-next-line:component-class-suffix
export class IntegrateLoyaltyComponentV2 implements OnInit {

  activeTab: any = 1;

  ngOnInit(): void {

  }

  selectTab() {
    console.log('this.activeTab', this.activeTab)
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty-v2/integrate-loyalty-v2.component.ts